module.exports = __webpack_public_path__ + "img/20220605_usdd_plan.a5daca0c.png";